<template>
  <v-card  style="background-color:#BDBFC1">
    <v-navigation-drawer
      permanent
      app
      left
      style="background-color:#6A8260;color:white"
      class="pa-3"
    >

  
      <template v-slot:prepend>
        <v-row>
          <v-btn icon to="/"> <v-icon color="white">mdi-arrow-left</v-icon></v-btn>
        </v-row>
         <v-row style="margin-top:10vh" no-gutters>
           <v-spacer></v-spacer>
            <v-avatar size="120">
      <img
        src="https://cdn.vuetifyjs.com/images/john.jpg"
        alt="John"
      >
    </v-avatar>
    <v-spacer></v-spacer>
         </v-row>
      </template>
      <br>
      <p class="text-center text-h6 font-weight-bold">Hi, {{teams.firstname}} {{teams.lastname}}</p>
      <p class="text-caption text-center">Teams ID:{{teams.teamid}}</p>
      <span class="mb-5"></span>
     <div>
        <p class="text-h4 grey--text text-center">Dashboard</p>
        <v-divider></v-divider>
        <v-list dense>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          @click="name=item.name"
        >
          <v-list-item-icon>
            <v-icon color="white">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="text-h6 white--text" >{{ item.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
     </div>

      <v-btn block class="green" style="text-transform:none" @click="signout" dark>Sign out</v-btn>

      
    </v-navigation-drawer>
    <div class="pa-10">
        <Order v-if="name=='Order'" />
    </div>
    
  </v-card>
</template>

<script>
import Order from '../components/Dashboard/Order.vue'

export default {
  components:{
    Order
  },
  data(){
    return {
      items:[
      {name:"Order",icon:"mdi-basket"},
      {name:"Meals",icon:"mdi-bowl-mix"},
      {name:"Transactions",icon:"mdi-cash-100"},
      {name:"Report",icon:" mdi-cloud-print-outline"}
    ],
    name:"Order",
    teams:JSON.parse(localStorage.getItem("teams"))
    }
  },
  methods:{
    signout(){
      localStorage.removeItem("admin")
      localStorage.removeItem("teams")
      this.$router.push('/admin/login')
    }
  }
  
}
</script>

<style>

</style>